import { useMemo } from 'react'
import { networkApi } from '@/core/api/network'
import { useAppSelector } from '@/redux/rootReducer'
import { skipToken } from '@reduxjs/toolkit/query'

export const {
  useGetNetworkQuery,
  useGetNetworkInvitationsQuery,
  useGetNetworkMembersQuery,
  useDiscoverNetworksQuery,
  useGetJoinedNetworksQuery,
  useLazyGetJoinedNetworksQuery,
  useGetNetworksQuery,
  useCreateNetworkMutation,
  useUpdateNetworkMutation,
  useDeleteNetworkMutation,
  useLeaveNetworkMutation,
  useSendNetworkInvitationMutation,
  useReplyNetworkInvitationMutation,
  useSendNetworkJoinRequestMutation,
  useReplyNetworkJoinRequestMutation,
  useRemoveNetworkMembersMutation,
  useUpdateMemberAccessLevelMutation,
  useUploadNetworkCoverMutation,
  useUpdateNetworkMemberMutation,
  useMarkConsultationsAsPaidMutation,
  useQueryWaitingRoomConsultationsQuery,
  useConvertMeetingLinkToConsultationMutation,
  useConvertMeetingLinkToExpertiseMutation,
  useExportWaitingRoomConsultationsQuery,
  useLazyExportWaitingRoomConsultationsQuery,
  useGetNetworkDesmosConfigQuery,
  useUpdateNetworkDesmosConfigMutation,
  useGetNetworkActConfigQuery,
  useUpdateNetworkActConfigMutation,
  useGetAvailableActsQuery,
  useGetWaitingRoomConsultationsSummaryQuery,
} = networkApi

export const useSelectNetwork = (networkId?: string) => {
  const selectNetwork = useMemo(() => networkApi.endpoints.getNetwork.select(networkId ?? skipToken), [networkId])

  return useAppSelector(selectNetwork)
}
